import { useLocation, useNavigate } from "react-router-dom";

import { OriginateFields } from "../components/OriginateFields";
import { TerminalFrame } from "../components/TerminalFrame";
import { Button } from "../components/ui";
import type { CallSetup as CallSetupPayload } from "../lib/types";
import { useCallSetup } from "../lib/useCallSetup";

/**
 * Full-page terminal originate form. Same fields as the console drawer.
 */
export function CallSetup() {
  const navigate = useNavigate();
  const location = useLocation();
  const prefill = (location.state as { setup?: CallSetupPayload } | null)?.setup ?? null;
  const setup = useCallSetup({
    active: true,
    prefill,
    onDialed: () => navigate("/console"),
  });
  const { busy } = setup;
  const dialBlocked = setup.dialBlocked;

  return (
    <div className="flex min-h-0 flex-1 flex-col p-4">
      <TerminalFrame
        title="cdialer@ops — originate"
        status={<span>Dial originates · Enter optionally advances</span>}
        footer={
          <div className="flex flex-wrap items-center justify-end gap-3">
            <div className="flex flex-col items-end gap-1">
              {setup.dialReason ? (
                <p className="font-mono text-[11px] text-mute">{setup.dialReason}</p>
              ) : null}
              <div className="flex flex-wrap gap-2">
              <Button
                variant="primary"
                className="min-h-11"
                disabled={dialBlocked}
                onClick={() => void setup.submitDial()}
              >
                Dial
              </Button>
              <Button variant="ghost" className="min-h-11" disabled={busy} onClick={() => navigate("/console")}>
                Cancel
              </Button>
              <Button variant="ghost" className="min-h-11" disabled={busy} onClick={() => void setup.saveProfile()}>
                Save profile
              </Button>
              <Button variant="danger" className="min-h-11" disabled={busy} onClick={() => void setup.deleteProfile()}>
                Delete
              </Button>
              </div>
            </div>
          </div>
        }
      >
        <form
          className="scroll-thin min-h-0 flex-1 space-y-4 overflow-auto p-5"
          onSubmit={(event) => void setup.submitDial(event)}
        >
          <OriginateFields setup={setup} onDesign={() => navigate("/scripts")} />
        </form>
      </TerminalFrame>
    </div>
  );
}
